import { ReactNode } from 'react'
import { classNames } from '../../_helpers'

type PropType = {
  label: string | ReactNode;
  name?: string;
  description?: string;
  checked: boolean;
  small?: boolean;
  setValue: (checked: boolean) => void;
  isRequired?: boolean,
  bold?: boolean
  disabled?: boolean
  isPrivate?: boolean
  radio?: boolean
}

export const Checkbox = ({ label, name, description, checked, setValue, small, isRequired, bold, disabled, isPrivate, radio }: PropType) => {
  return (
    <label className="relative flex items-start gap-3">
      <span className="flex h-5 shrink-0 items-center">
        <input
          // id={id}
          name={name}
          type={radio ? 'radio' : 'checkbox'}
          checked={checked}
          disabled={disabled}
          onChange={e => {
            setValue(e.target.checked)
          }}
          required={isRequired || false}
          className={classNames(
            'h-5 w-5 shrink-0 cursor-pointer appearance-none border border-gray-300 bg-white bg-center bg-no-repeat p-0 shadow-xs transition-all duration-150 hover:border-primary focus:outline-none focus-visible:ring-4 focus-visible:ring-primary/20 checked:border-primary checked:bg-primary disabled:cursor-not-allowed disabled:border-gray-200 disabled:bg-gray-100 disabled:checked:bg-gray-300',
            radio ? 'rounded-full ui-radio' : 'rounded-md ui-checkbox'
          )}
        />
      </span>
      <span className="block text-sm">
        <span
          // htmlFor={id}
          className={classNames(
            "block font-medium",
            small ? 'text-xs' : 'text-sm',
            isRequired || bold ? 'font-bold' : '',
            disabled ? 'text-gray-400' : 'text-gray-700'
          )}
        >
          {label}
        </span>
        {description && (
          <span className={classNames(
            'block text-gray-500 whitespace-pre-wrap',
            small ? 'text-xs leading-tight' : '',
          )}>
            {description}
          </span>
        )}
      </span>
    </label>
  )
}
